module.exports = __webpack_public_path__ + "img/dashboard.f577e6b3.svg";